<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="tariffed_device_is_load" parent="tariffed_device">
    <tab id="info" :name="translate('tariffed_device.section.info')" :href="url+'/info'">
      <Info v-if="tariffed_device_is_load"
        :tariffed_device="tariffed_device_info"
        @update="get_tariffed_device"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Tariffed Device: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/tariffication/tariffed_devices'}">
              To Tariffed Device list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Info from './Tabs/Info/Index.vue'

export default {
  name: 'TariffedDevice',
  components: {
    Info,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      tariffed_device_info: {},
    }
  },

  computed: {
    url () { return '/tariffed_device/' + this.$route.params.tariffed_device_id },
    cur_id () { return this.$route.params.tariffed_device_id },
    load () { return !this.tariffed_device_info?.id },
    tariffed_device_is_load() { return this.tariffed_device_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'tariffed_device_section') {
        this.get_tariffed_device()
      }
    }
  },

  activated(){
    this.get_tariffed_device()
  },

  destroyed() {
    this.tariffed_device_info = {}
  },

  methods: {
    get_tariffed_device () {
      this.$http.v1.getTariffDeviceInfo(this.$route.params.tariffed_device_id, (response) => {
        this.tariffed_device_info = response.data
        this.$store.commit('updateSelectedTariffedDevice', response.data)
      })
    }
  }
}

</script>
